export const sizes = { small: 16, medium: 24, large: 32 };
